import {
  Card,
  CardContent,
  CardHeader,
  EmptyState,
  Grid,
  MenuItem,
  SelectField,
  Stack,
} from '@all-manager/design-system-v2';
import { Pie } from 'react-chartjs-2';
import { ExpenseCategoryDatabase, ExpenseDatabase } from '../../../../types';
import CategoryTotalsTable from '../CategoryTotalsTable/CategoryTotalsTable';
import { useYearBreakdown } from './useYearBreakdown';

type Props = {
  categories: ExpenseCategoryDatabase[];
  expenses: ExpenseDatabase[];
};

export default function YearBreakdown(props: Props) {
  const hook = useYearBreakdown(props);

  return (
    <Stack spacing={2}>
      <div>
        <SelectField<number>
          label="Année"
          value={hook.selectedYear}
          onChange={(event) => hook.handleYearChange(Number(event.target.value))}
        >
          {hook.years.map((year) => (
            <MenuItem key={year} value={year}>{year}</MenuItem>
          ))}
        </SelectField>
      </div>

      {hook.totals.length === 0 ? (
        <Card>
          <EmptyState
            title={`Aucune dépense en ${hook.selectedYear}`}
            subtitle="Choisissez une autre année, ou ajoutez des dépenses depuis l'onglet Par catégorie."
          />
        </Card>
      ) : (
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 7 }}>
            <Card>
              <CardHeader title={`Répartition des dépenses ${hook.selectedYear}`} />
              <CardContent>
                <Pie
                  data={hook.chartData}
                  options={hook.chartOptions}
                  aria-label={`Répartition des dépenses ${hook.selectedYear} par catégorie, détaillée dans le tableau`}
                  role="img"
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid size={{ xs: 12, md: 5 }}>
            <Card>
              <CardHeader title="Montants par catégorie" />
              <CategoryTotalsTable
                aria-label={`Montants par catégorie en ${hook.selectedYear}`}
                totals={hook.totals}
              />
            </Card>
          </Grid>
        </Grid>
      )}
    </Stack>
  );
}
